import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { landingContent } from '@/constants/landing-content';

const { faq } = landingContent;

export function FaqSection() {
  return (
    <section id={faq.id} className="py-16 md:py-24">
      <div className="container mx-auto max-w-3xl px-4">
        <h2 className="text-foreground text-center text-3xl font-bold tracking-tight md:text-4xl">
          {faq.headline}
        </h2>

        <div className="mt-12">
          <Accordion type="single" collapsible className="w-full">
            {faq.items.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-base font-medium">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
